import { inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { AuthService } from '../services/auth.service';

export function injectCurrentContext() {
  return toSignal(inject(AuthService).currentContext$);
}
